import { MB_CONFIG } from '../config'

export default {

    /*
    *   Get current logged in user information
    *   GET /api/v1/app/user
    */
    user: () => {
        return axios.get(MB_CONFIG.API_URL + '/app/user')
    },

    /*
    *   Update the profile
    *   PUT /api/v1/app/user
    */
    profile: (user) => {
        return axios.put(MB_CONFIG.API_URL + '/app/user', user)
    },

}
